export const api_configs = {
	baseUrl: process.env.REACT_APP_BASE_URL || "https://exam-api.somatmba.com/v1",
}
